import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '@app/shared/config/app.config';
import { IDtoResponse } from '@app/shared/models/dtos/response.dto';
import { ICustomerBelongToPbPortFolio } from '@app/shared/models/personal-banker.model';
import { map, Observable, of } from 'rxjs';
import { ServiceBase } from '../base/base.service';

@Injectable({
  providedIn: 'root',
})
export class HelpCenterService extends ServiceBase {
  constructor(private readonly _http: HttpClient) {
    super(`${APP_CONFIG.serviceBaseUrl}/cx/api/help-center/v1`);
  }

  getCustomerBelongToPbPortfolio(pbEmail: string, rppUserId: string): Observable<boolean | undefined> {
    return this._http
      .get<IDtoResponse<ICustomerBelongToPbPortFolio>>(`${this.baseUrl}/${rppUserId}/portofolio/belog`, {
        params: {
          agent_email: pbEmail,
        },
      })
      .pipe(map(res => res.data?.customer_in_port_folio));
  }

  getGoogleAuthorizationURL(email: string): Observable<string> {
    return this._http
      .get<IDtoResponse<string>>(`${this.baseUrl}/authorization`, {
        params: new HttpParams().set('email', email),
      })
      .pipe(map(result => result.data || ''));
  }

  setGoogleAuthorization(email: string, code: string): Observable<string | undefined> {
    return this._http
      .get<IDtoResponse<string>>(`${this.baseUrl}/authorization-code`, {
        params: new HttpParams().set('email', email).set('code', code),
      })
      .pipe(map(result => result.data));
  }

  getGoogleCalendarValidation(email: string): Observable<any> {
    return this._http
      .get<IDtoResponse<any>>(`${this.baseUrl}/validation`, {
        params: new HttpParams().set('email', email),
      })
      .pipe(map(result => result.data));
  }
}
